var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"configurator"}},[_c('TransitionNavigate',[(_vm.ready)?_c('router-view'):_vm._e()],1),_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }